import { Selection } from './../../../3rdparty/walkontable/src';

/**
 * @return {Selection}
 */
function createHighlight({ activeHeaderClassName }) {
  const s = new Selection({
    highlightHeaderClassName: activeHeaderClassName,
  });

  return s;
}

export default createHighlight;



// WEBPACK FOOTER //
// ./node_modules/handsontable/src/selection/highlight/types/activeHeader.js